/**
 * @description 获取当前时间
 * @param format 时间格式
 */
const getCurrentTime = (format: any) => {
    const now: any = new Date();
    const year: any = now.getFullYear(); // 得到年份
    let month: any = now.getMonth(); // 得到月份
    let date: any = now.getDate(); // 得到日期
    let hour: any = now.getHours(); // 得到小时
    let minu: any = now.getMinutes(); // 得到分钟
    let sec: any = now.getSeconds(); // 得到秒
    month = month + 1;
    if (month < 10) {
        month = "0" + month;
    }
    if (date < 10) {
        date = "0" + date;
    }
    if (hour < 10) {
        hour = "0" + hour;
    }
    if (minu < 10) {
        minu = "0" + minu;
    }
    if (sec < 10) {
        sec = "0" + sec;
    }
    let time = "";
    if (format == "yyyy") {
        time = year
    } else if (format == "yyyy-MM") {
        time = year + "-" + month
    } else if (format == "yyyy-MM-dd") {
        time = year + "-" + month + "-" + date
    } else if (format == "yyyy-MM-dd HH") {
        time = year + "-" + month + "-" + date + " " + hour
    } else if (format == "yyyy-MM-dd HH:mm") {
        time = year + "-" + month + "-" + date + " " + hour + ":" + minu
    } else if (format == "yyyy-MM-dd HH:mm:ss") {
        time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
    }
    return time;
}
/**
 * @description 获取指定天数前的日期
 * @param days 天数
 */
const getDaysAgo = (days: any) => {
    const today = new Date();
    today.setDate(today.getDate() - days);
    return today;
}
/**
 * @description 获取临近时间范围
 * @param key  近7天，近1个月，近3个月，近半年，近1年
 */
const getTimeRange = (days: any) => {
    if (days == '近7天') {
        return getPastSevenDaysRange()
    } else if (days == '近1个月') {
        return getPastMonthRange();
    } else if (days == '近3个月') {
        return getPastThreeMonthsRange()
    } else if (days == '近半年') {
        return getPastSixMonthsRange()
    } else if (days == '近1年') {
        return getPastYearRange()
    }
}
/**
 * @description 获取近7天的日期范围
 */
const getPastSevenDaysRange = () => {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 7);
    return [startDate, endDate];
}
/**
 * @description 获取近1个月的日期范围
 */
const getPastMonthRange = () => {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setMonth(startDate.getMonth() - 1);
    // 如果上个月的天数少于这个月，需要调整日期  
    if (startDate.getDate() > endDate.getDate()) {
        startDate.setDate(startDate.getDate() - (endDate.getDate() - startDate.getDate()) + 1);
    }
    return [startDate, new Date(endDate.getFullYear(), endDate.getMonth(), 1)];
}
/**
 * @description 获取近3个月的日期范围
 */
const getPastThreeMonthsRange = () => {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setMonth(startDate.getMonth() - 3);
    // 调整日期  
    adjustStartOfMonth(startDate, endDate);
    return [startDate, new Date(endDate.getFullYear(), endDate.getMonth(), 1)];

}
/**
 * @description 获取近半年的日期范围 
 */
const getPastSixMonthsRange = () => {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setMonth(startDate.getMonth() - 6);
    // 调整日期  
    adjustStartOfMonth(startDate, endDate);
    return [startDate, new Date(endDate.getFullYear(), endDate.getMonth(), 1)];

}
/**
 * @description 获取近1年的日期范围
 */
const getPastYearRange = () => {
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setFullYear(startDate.getFullYear() - 1);
    // 调整日期  
    adjustStartOfMonth(startDate, endDate);
    return [startDate, new Date(endDate.getFullYear(), 0, 1)]; // 0代表一月的第一天  

}
/**
 * @description 辅助函数：调整日期为月初的第一天
 */
const adjustStartOfMonth = (startDate: any, endDate: any) => {
    while (startDate.getDate() !== 1) {
        startDate.setDate(startDate.getDate() - 1);
    }
}

/**
 * @description 树结构格式化，把打平的直接处理成嵌套的格式
 * @param data 需要处理的数据,打平的数据
 * @param idKey 唯一识别字段，不传就是id
 * @param parentKey 父结构字段，不传就是parent
 * @param childrenKey 子集字段，不传就是children
 * @returns 
 */
const BuildTree = (data: any, idKey: any = "id", parentKey: any = "parent", childrenKey: any = 'children') => {
    // 创建一个map，以id为键，以对应的对象为值  
    let map: any = {};
    data.forEach((item: any) => {
        map[item[idKey]] = { ...item };
        map[item[idKey]][childrenKey] = [];
        map[item[idKey]].level = 1;
    });

    // 递归函数，用于构建树形结构并设置level字段  
    function buildTreeRecursive(parentId: any, level: any) {
        let tree: any = [];
        data.forEach((item: any) => {
            if (item[parentKey] === parentId) {
                const newNode = { ...map[item[idKey]], level: level }; // 设置当前节点的level  
                newNode[childrenKey] = buildTreeRecursive(item[idKey], level + 1); // 递归构建子节点  
                tree.push(newNode);
            }
        });
        return tree;
    }
    // 构建树的根节点，level为0  
    const tree = buildTreeRecursive(null, 1);
    return tree;
}
/**
 * @description  把obj数组处理成str数组
 * @param data 需要处理的数据 
 * @param idKey 需要提取的字段字段，不传就是id,
 * @param filterKey 需要过滤的字段
 * @param filterKValue 需要过滤的值
 * @returns 
 */
const GetIdArr = (data: any, idKey: any = "id", filterKey?: any, filterValue?: any) => {
    let arr: any = [];
    if (data.length > 0) {
        data.forEach((item: any) => {
            if (filterKey) {
                if (item[filterKey] == filterValue) {
                    arr.push(item[idKey])
                }

            } else {
                arr.push(item[idKey])
            }

        });
    }

    return arr;
}
/**
 * @description 根据中文名字找英文字段
 * @param name 中文名称
 * @returns 
 */
const GetKey = (name: any) => {
    let key: any = '';
    switch (name) {
        case '疾病诊断':
            key = 'disease_diagnosis'
            break;
        case '既往史':
            key = 'past_history'
            break;
        case '过敏史':
            key = 'allergy_history'
            break;
        case '用药史':
            key = 'drug_history'
            break;
        case '家族史':
            key = 'family_history'
            break;
        case '心血管病史':
            key = 'heart_disease_history'
            break;
        case '生活方式':
            key = 'lifestyle'
            break;

        default:
            break;
    }
    return key;
}
/**
 * @description 清除filter
 * @param data{}
 * @returns 
 */
const clearFilter = () => {
    localStorage.setItem("cepingFilter", "");
    localStorage.setItem("accountFilter", "");
    localStorage.setItem("qudaoFilter", "");
    localStorage.setItem("manageFilter", "");
    localStorage.setItem("jiangkangcepingFilter", "");
    localStorage.setItem("knowledgeFilter", "");
}
export {
    getCurrentTime, clearFilter, BuildTree, GetIdArr, GetKey,
    getDaysAgo, getTimeRange, getPastSevenDaysRange, getPastMonthRange, getPastThreeMonthsRange,
    getPastSixMonthsRange, getPastYearRange
};